module.exports = __webpack_public_path__ + "img/BS00.eceb7f13.svg";